import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { DatePipe, registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import localeSr from '@angular/common/locales/sr-Latn';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { authInterceptor, AuthModule } from './core/auth';
import { STATE_STORAGE, StorageSyncType } from './core/storage';
import { StaticTranslationLoader } from './core/services';
import { apiInterceptor, appErrorInterceptor } from './core/http-interceptors';
import RbPreset from './rb-preset';
import { LayoutService } from './services';
import { EnvironmentStore } from './components/environment/environment.store';

registerLocaleData(localeSr, 'sr-RS');

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'sr-RS' },
    { provide: STATE_STORAGE, useValue: StorageSyncType.LOCAL_STORAGE },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      })
    ),
    provideHttpClient(withFetch(), withInterceptors([apiInterceptor, authInterceptor, appErrorInterceptor])),
    importProvidersFrom(AuthModule.forRoot()),
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: StaticTranslationLoader,
        },
      }),
    ]),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: RbPreset,
        options: {
          darkModeSelector: 'rb-dark',
        },
      },
    }),
    provideAppInitializer(() => {
      const appInfo = inject(EnvironmentStore);
      return appInfo.getEnvironment();
    }),
    DatePipe,
    MessageService,
    ConfirmationService,
    LayoutService,
  ],
};
